// import 'jquery-migrate';
import 'jquery-match-height';
import 'picturefill';
import {App} from './lib/app';

import Vue      from 'vue';
import Raven    from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

try {
	if(window.environments.env !== 'DEV' && window.environments.sentry_dsn) {
		const config = {
			release:     window.environments.release,
			environment: window.environments.env
		};
		Raven.config(window.environments.sentry_dsn, config)
			 .addPlugin(RavenVue, Vue)
			 .install();
	}
} catch(e) {
	console.log(e);
}

const app = new App();

// Match Height settings
app.matchHeight.selector = [
	'.block--icon__title',
	'.block--promo__title'
];

// Tooltips settings
app.tooltips.selector = '[rel~=tooltip]';
app.tooltips.id       = 'tooltip';

app.init();

/**
 * Password strength indicator.
 * @param $pass1
 * @param $pass2
 * @param $strengthResult
 * @param $submitButton
 * @param blacklistArray
 * @returns {*}
 */
function checkPasswordStrength( $pass1, $pass2, $strengthResult, $submitButton, blacklistArray ) {
	var pass1 = $pass1.val();
	var pass2 = $pass2.val();
	// Reset the form & meter
	$submitButton.attr( 'disabled', 'disabled' );
	$strengthResult.removeClass( 'short bad good strong' );
	// Extend our blacklist array with those from the inputs & site data
	blacklistArray = blacklistArray.concat( wp.passwordStrength.userInputBlacklist() );
	// Get the password strength
	var strength = wp.passwordStrength.meter( pass1, blacklistArray, pass2 );
	console.log(strength);
	// Add the strength meter results
	switch ( strength ) {
		case 1:
			$strengthResult.addClass( 'bad' ).html( pwsL10n.bad );
			break;

		case 2:
			$strengthResult.addClass( 'bad' ).html( pwsL10n.bad );
			break;

		case 3:
			$strengthResult.addClass( 'good' ).html( pwsL10n.good );
			break;

		case 4:
			$strengthResult.addClass( 'strong' ).html( pwsL10n.strong );
			break;

		case 5:
			$strengthResult.addClass( 'short' ).html( pwsL10n.mismatch );
			break;

		default:
			$strengthResult.addClass( 'short' ).html( pwsL10n.short );

	}
	// The meter function returns a result even if pass2 is empty,
	// enable only the submit button if the password is strong and
	// both passwords are filled up
	if ( (5 !== strength && 0 !== strength) && '' !== pass2.trim() ) {
		$submitButton.removeAttr( 'disabled' );
	}

	return strength;
}

// password strength indicator
$( 'body' ).on( 'keyup', 'input[name=pass1], input[name=pass2]', function( event ) {
		checkPasswordStrength(
			$('input[name=pass1]'),            // First password field
			$('input[name=pass2]'),            // Second password field
			$('#passwd-strength-result'),           // Strength meter
			$('input[type=submit]'),           // Submit button
			['black', 'listed', 'word']        // Blacklisted words
		);
	}
);

